import type { SavingSettingsDetailsCountryConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsCountryConfig = {
    displayDisposableBalance: true,
    creditInterestRateTooltipHuSpecificTranslation: true,
    shouldDisplayCreditInterestRateWithTooltip: true,
    averageSavings: {
        displayAccountOwner: true,
        displayDashedBBAN: true,
        displayIban: true,
        displayBIC: true,
    },
    termDeposit: {
        displayAccountOwner: true,
        displayDashedBBAN: true,
    },
};
